<div #scrollContainer 
     class="toast-container position-fixed bottom-0 end-0 p-3 overflow-y-auto"
     [class.is-scrolling]="isScrolling()"
     (scroll)="onScroll()">
@for (toast of toastService.toasts(); track toast.id) {
<ngb-toast [class]="toast.classname + ' border-0  position-relative overflow-hidden custom-toast'"
    [autohide]="!toast.sticky" [delay]="toast.delay || 5000" (hidden)="toastService.remove(toast)">
    @if(toast.template != null){
        <ng-template [ngTemplateOutlet]="toast.template"></ng-template>
    }@else{
        <div class="d-flex w-100 align-items-center p-2">
            <div class="toast-body d-flex align-items-center flex-grow-1">
                <span class="text-white">{{toast.text}}</span>
            </div>

            <button type="button" class="btn-close btn-close-white me-2 m-auto" aria-label="Close"
                (click)="toastService.remove(toast)"></button>
        </div>

        @if (!toast.sticky) {
        <div class="toast-progress-container">
            <div class="toast-progress-bar" [style.transition-duration.ms]="toast.delay || 5000">
            </div>
        </div>
        }
    }
</ngb-toast>
}
</div>